import { memo } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'ramda';
import * as Styled from './Styled';
const Layout = ({
  id,
  placeholder,
  value,
  innerRef,
  isDisabled = false,
  isReadonly = false,
  isValid,
  isFocused,
  isTouched,
  tag: Tag = 'input',
  tagProps = {},
  labelName,
  errors = [],
  ...attributes
}) => {
  const isValidPropPresent = isValid !== undefined;
  const hasErrors = !isValid && !isEmpty(errors);
  return /*#__PURE__*/React.createElement(Styled.Wrapper, {
    isDisabled: isDisabled,
    isFocused: isFocused,
    isHasValue: !!value,
    isInvalid: isValidPropPresent && !isValid && isTouched
  }, /*#__PURE__*/React.createElement(Styled.Label, {
    htmlFor: id
  }, labelName), /*#__PURE__*/React.createElement(Styled.Field, null, /*#__PURE__*/React.createElement(Tag, {
    type: "text",
    spellCheck: false,
    placeholder: placeholder,
    id: id,
    ref: innerRef,
    disabled: isDisabled,
    value: value,
    ...tagProps,
    ...attributes,
    ...(isReadonly && {
      readonly: 'readonly'
    })
  }), hasErrors && /*#__PURE__*/React.createElement(Styled.Error, null, errors)));
};
Layout.propTypes = {
  /** [in development] need for create input or other node */tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  /** path down refs */innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.string]),
  /** is field id */id: PropTypes.string,
  /** is field placeholder */placeholder: PropTypes.string,
  /** is field value */value: PropTypes.string,
  /** default field value */defaultValue: PropTypes.string,
  /** is field label name */labelName: PropTypes.string,
  /** is field disabled */isDisabled: PropTypes.bool,
  /** is field readonly */isReadonly: PropTypes.bool,
  /** is field valid */isValid: PropTypes.bool,
  /** is field focused */isFocused: PropTypes.bool,
  /** is field has been touched */isTouched: PropTypes.bool,
  /** [in development] size of field */size: PropTypes.string,
  /** inner nodes */children: PropTypes.node,
  /** additional classes for field */className: PropTypes.string,
  /** tag props, only for specific case * */tagProps: PropTypes.object,
  errors: PropTypes.arrayOf(PropTypes.string)
};
export default /*#__PURE__*/memo(Layout);